module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (65).c3d6f0d6.jpg";